import { LucideShoppingCart, LucideCircleCheckBig, LucideHeart } from "lucide-react";
import { useState } from "react";
import { IconData, getIconThumbnail } from "../../data/icons";
import { Card } from "../ui/Card";
import {IconSummaryPopup} from "./IconSummaryPopup";

export interface IconProps {
    data: IconData;
}

export const Icon = (props: IconProps) => {
    const { data } = props;
    
    const [isIconPopupSummaryOpen, setIconPopupSummaryOpen] = useState(false);
    
    const [isAddedToWishlist, setAddToWishlist] = useState(false);
    function toggleWishlist() {
        setAddToWishlist(prev => !prev);
    }

    const [isAddedToCart, setAddToCart] = useState(false);
    function toggleCart() {
        setAddToCart(prev => !prev);
    }

    return (
        <>
            <Card
                padding="small"
                position="center"
                hover={true}
                onClick={() => setIconPopupSummaryOpen(true)}
                className={`aspect-square relative group transition-all duration-300 ease-in-out bg-brand-500/20
                ${isAddedToCart ? 'border-2 border-brand-300 bg-brand-400' : 'border-surface-950'}`}
            >
                
                <IconImage title={data.name} url={getIconThumbnail(data.previewImage, 256)} />
                {/*<WishlistButton isAdded={isAddedToWishlist} addToWishlist={toggleWishlist} />*/}

                <div
                    className="absolute bottom-0 right-0 p-2 opacity-100 translate-y-0 lg:opacity-0 lg:translate-y-full 
                               lg:group-hover:opacity-100 lg:group-hover:translate-y-0 lg:group-focus-within:opacity-100 
                               lg:group-focus-within:translate-y-0 transition-all duration-300 ease-in-out z-20"
                >
                    <div className="bg-surface-50/10 backdrop-blur-md rounded-lg p-1 flex items-center gap-1 shadow-lg">
                        <AddToCartButton isAdded={isAddedToCart} addToCart={toggleCart} />
                    </div>
                </div>
            </Card>
            
            <IconSummaryPopup
                iconData={data}
                isOpen={isIconPopupSummaryOpen}
                onClose={() => setIconPopupSummaryOpen(false)}
            />
        </>
    );
};

export interface IconImageProps {
    url: string;
    title: string;
}

const IconImage = ({ url, title }: IconImageProps) => {
    return (
        <div className="flex-grow flex items-center justify-center">
            <img
                src={url}
                alt={title}
                className="max-w-[130px] max-h-[130px] transition-transform duration-300 group-hover:scale-110"
            />
        </div>
    );
};

type AddToCartButtonProps = {
    isAdded: boolean;
    addToCart: () => void;
};

const AddToCartButton = (props: AddToCartButtonProps) => {
    return (
        <button
            onClick={props.addToCart}
            className="cart-btn flex-grow bg-brand-500 text-surface-950 hover:bg-brand-700 active:scale-[0.98] 
                disabled:bg-surface-300 disabled:text-surface-600 disabled:cursor-not-allowed rounded-md h-8 w-10 
               flex items-center justify-center text-xs font-bold transition-all duration-200"
        >
            
            <span className="btn-text inline-flex items-center gap-1">
                {props.isAdded ? <LucideCircleCheckBig /> : <LucideShoppingCart />}
            </span>

        </button>
    );
};

type AddToWishlistButtonProps = {
    isAdded: boolean;
    addToWishlist: () => void;
};

const WishlistButton = (props: AddToWishlistButtonProps) => {
    return (
        <button
            onClick={props.addToWishlist}
            aria-label="Add to Wishlist"
            className={`absolute top-2 right-2 wishlist-btn flex-shrink-0 w-6 h-6 hover:text-red-500 
            active:scale-[0.98] rounded-md flex items-center justify-center transition-all duration-200 
            ${props.isAdded ? "text-red-500" : ""}`}
        >
            {props.isAdded ? <LucideHeart fill="currentColor" stroke="none" /> : <LucideHeart />}
        </button>
    );
};






